import { render } from "./SuggestionsHome.vue?vue&type=template&id=64e3d866&scoped=true"
import script from "./SuggestionsHome.vue?vue&type=script&lang=js"
export * from "./SuggestionsHome.vue?vue&type=script&lang=js"

import "./SuggestionsHome.vue?vue&type=style&index=0&id=64e3d866&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e3d866"]])

export default __exports__